import { knowledgebase } from './knowledgebase';
import pricingPlans from './pricing-plans';
import searchElements from './search-elements';

$(() => {
  const FEJS = {
    knowledgebase,
    pricingPlans,
    searchElements,
    initialize: () => {
      const common = $('body').data('jscommon');
      const page = $('body').data('jspage');

      if (typeof common !== 'undefined') {
        FEJS[common]();
      }
      if (typeof page !== 'undefined' && Object.prototype.hasOwnProperty.call(FEJS, page)) {
        FEJS[page]();
      }
    },
  };

  FEJS.initialize();
});



// WEBPACK FOOTER //
// ./static-pages/main.js